/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Pricing_Meta_DescriptionInputs */

const ja_playdata_pricing_meta_description = /** @type {(inputs: Playdata_Pricing_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYDATA（プレイデータ）のプラン・価格について紹介しています。`)
};

const en_playdata_pricing_meta_description = /** @type {(inputs: Playdata_Pricing_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYDATA esports event report plans and pricing.`)
};

/**
* | output |
* | --- |
* | "PLAYDATA esports event report plans and pricing." |
*
* @param {Playdata_Pricing_Meta_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_pricing_meta_description = /** @type {((inputs?: Playdata_Pricing_Meta_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Pricing_Meta_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_pricing_meta_description(inputs)
	return en_playdata_pricing_meta_description(inputs)
});